import { isNumber, memoize } from 'lodash';

const convertToPixelCrop = (crop, imageWidth, imageHeight) => ({
  x: (crop.x * imageWidth) / 100,
  y: (crop.y * imageHeight) / 100,
  width: (crop.width * imageWidth) / 100,
  height: (crop.height * imageHeight) / 100,
});

const loadImage = memoize(
  (src) =>
    new Promise((resolve, reject) => {
      var img = new Image();
      img.crossOrigin = 'Anonymous';
      img.addEventListener('load', () => resolve(img), true);
      img.src = src;
    })
);

const scaleImage = (options) => {
  let scale =
    options.scale ||
    Math.min(
      options.maxWidth / options.width,
      options.maxHeight / options.height
    );

  scale = Math.min(scale, options.maxScale || 1);

  return {
    scale,
    width: options.width * scale,
    height: options.height * scale,
  };
};

const isCropInitialized = (crop) => {
  const { width, height, x, y } = crop;
  return !isNaN(width) && !isNaN(height) && !isNaN(x) && !isNaN(y);
};

export default async (src, crop, max) => {
  if (!isCropInitialized(crop)) return src;
  const image = await loadImage(src);
  const { naturalWidth, naturalHeight } = image;
  const { width, height, x, y } = convertToPixelCrop(
    crop,
    naturalWidth,
    naturalHeight
  );

  var destWidth = width;
  var destHeight = height;

  if (max.width || max.height) {
    // Scale the crop.
    var scaledCrop = scaleImage({
      width: width,
      height: height,
      maxWidth: max.width,
      maxHeight: max.height,
    });

    destWidth = scaledCrop.width;
    destHeight = scaledCrop.height;
  }

  const canvas = document.createElement('canvas');
  canvas.width = destWidth;
  canvas.height = destHeight;

  const ctx: any = canvas.getContext('2d');
  ctx.drawImage(image, x, y, width, height, 0, 0, destWidth, destHeight);

  return canvas.toDataURL('image/jpeg');
};
